import { render, staticRenderFns } from "./HomeStayNums.vue?vue&type=template&id=20da0c6c"
import script from "./HomeStayNums.vue?vue&type=script&lang=js"
export * from "./HomeStayNums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports